export default __webpack_public_path__ + "static/media/progressbar.ff5741b1.png";